document.addEventListener("DOMContentLoaded", function () {
	init();
});

 
function init() {
	sliderPeriodicos();
	sliderRevistas();
	carouselRevistas();  
}
